import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Autocomplete,
} from "@mui/material";
import { FilterAltOutlined } from "@mui/icons-material";
import { keyframes } from "@mui/system";
import {
  primaryDark,
  accentColor,
  buttonGradient,
  buttonGradientHover,
} from "../../../constants/consts";

const popIn = keyframes`
  from { opacity: 0; transform: scale(0.92); }
  to   { opacity: 1; transform: scale(1); }
`;

const normalize = (s = "") => String(s).toLocaleLowerCase("tr-TR").trim();

const EMPTY = { sunucuKodu: "", eduDate: "" };

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    transition: "box-shadow 0.25s ease, background-color 0.25s ease",
    "&:hover": { backgroundColor: "rgba(4,87,129,0.02)" },
    "&.Mui-focused": { boxShadow: "0 0 0 4px rgba(4,87,129,0.10)" },
  },
};

export default function EduFilterDialog({
  open,
  onClose,
  onApply,
  sunucuKoduList = [],
}) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (open) setForm(EMPTY);
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          animation: `${popIn} 0.25s cubic-bezier(0.22, 1, 0.36, 1) both`,
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          px: 3,
          py: 1.75,
          background: `linear-gradient(135deg, ${primaryDark} 0%, ${accentColor} 100%)`,
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            color: "#fff",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <FilterAltOutlined sx={{ fontSize: 20 }} />
          Filtre Uygula
        </DialogTitle>
      </Box>

      <DialogContent sx={{ pt: 3 }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 2,
          }}
        >
          <Autocomplete
            size="small"
            options={sunucuKoduList}
            value={form.sunucuKodu || null}
            onChange={(_, v) =>
              setForm((prev) => ({ ...prev, sunucuKodu: v || "" }))
            }
            filterOptions={(opts, { inputValue }) =>
              opts.filter((o) => normalize(o).includes(normalize(inputValue)))
            }
            noOptionsText="Sunucu bulunamadı"
            renderInput={(params) => (
              <TextField
                {...params}
                label="Sunucu Kodu"
                placeholder="Yaz veya seç"
                sx={inputSx}
              />
            )}
          />

          <TextField
            label="Eğitim Tarihi"
            type="date"
            value={form.eduDate}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, eduDate: e.target.value }))
            }
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            sx={inputSx}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ textTransform: "none", borderRadius: 2 }}
        >
          İptal
        </Button>
        <Button
          onClick={() => {
            onApply?.(form);
            onClose?.();
          }}
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 700,
            background: buttonGradient,
            "&:hover": { background: buttonGradientHover },
          }}
        >
          Uygula
        </Button>
      </DialogActions>
    </Dialog>
  );
}
